import React, { useCallback, useMemo, useRef } from "react";
import _ from "lodash";
import { Request } from "@codeArt/request";
import { wrap } from "@codeArt/utils/promise";
import App from "@codeArt/apps/app";


//从插件管理器中得到开通了哪些插件,id:插件管理器的编号
const getPredicate = (id)=>{ //以下方法的意思是，用promise模式获得一个过滤方法
    return wrap((resolve, reject)=>{
        Request(
        {
            url: "/GetPluginManager",
            data: {id},
            success: r => {
                resolve(
                    (p)=>Boolean(_.find(r.PluginIds,(id)=> p.id===id))
                );
            }
        },
        App.dispatch()
        );
    });
}


export { getPredicate };